export default __webpack_public_path__ + "static/tetris-preview-2-arg-fde24c107d8d34a5461c8e068f276997.png";